export default "__VITE_ASSET__DfACd7jG__"